// ProductSelector.jsx
import React, { useState } from "react";

const ProductSelector = ({ isOpen, onClose, onSelect, products: initialProducts = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  // Utilize os produtos recebidos via prop
  const products = initialProducts;

  const filteredProducts = products.filter((product) => {
    const matchesSearch =
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.code.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === "all" || product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg w-full p-6 max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Selecionar Produto</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ×
          </button>
        </div>

        {/* Filtros */}
        <div className="flex flex-col sm:flex-row gap-4 mb-4">
          <div className="flex-1">
            <input
              type="text"
              placeholder="Buscar produto..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-2 border rounded-md"
            />
          </div>
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="p-2 border rounded-md"
          >
            <option value="all">Todas as categorias</option>
            <option value="gas">Gás</option>
            <option value="kit">Kit Regulador</option>
            <option value="acessorios">Acessórios</option>
          </select>
        </div>

        {/* Lista de Produtos */}
        <div className="flex-1 overflow-y-auto">
          {products.length === 0 ? (
            <p className="text-center text-gray-600 my-5">Carregando produtos...</p>
          ) : filteredProducts.length === 0 ? (
            <p className="text-center text-gray-600 my-5">Nenhum produto encontrado.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {filteredProducts.map((product) => (
                <div
                  key={product.id}
                  className="border rounded-lg p-4 flex flex-col sm:flex-row gap-4 hover:bg-gray-50 cursor-pointer"
                  onClick={() => onSelect(product)}
                >
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full sm:w-24 h-24 object-cover rounded-md"
                  />
                  <div className="flex-1">
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-500">{product.code}</span>
                      <span
                        className={`text-sm font-medium ${
                          product.stock > 0 ? "text-green-600" : "text-red-600"
                        }`}
                      >
                        {product.stock > 0 ? `${product.stock} un` : "Indisponível"}
                      </span>
                    </div>
                    <h3 className="font-medium text-gray-800">{product.name}</h3>
                    <p className="text-sm text-gray-600 mt-1">{product.description}</p>
                    <p className="text-lg font-bold text-red-600 mt-2">
                      R$ {product.price.toFixed(2)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductSelector;
